import { Text } from 'react-native'
import { styled } from '~/core/styled'

import { convertLineHeight, convertPercentageToNumber } from '~/utils'

type CaptionProps = React.ComponentPropsWithRef<typeof Caption>

const Caption = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreepulse,
      color: theme.colorTextNeutralDefault,

      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      textDecorationLine: theme.textDecorationLineNone,
    },
    variants: {
      variant: {
        'default-bold': {
          fontFamily: theme.fontFamily.bold,
        },
        'underline-bold': {
          fontFamily: theme.fontFamily.bold,
          textDecorationLine: theme.textDecorationLineUnderline,
        },
        'default-semibold': {
          fontFamily: theme.fontFamily.semiBold,
        },
        'underline-semibold': {
          fontFamily: theme.fontFamily.semiBold,
          textDecorationLine: theme.textDecorationLineUnderline,
        },
      },
    },
  }
})

export { Caption }
export type { CaptionProps }
